import { createFileRoute } from '@tanstack/react-router';

import { EditActivityForm } from '@/areas/manufacturing-templates/Activities/ActivityCreation/EditActivityForm';
import { canEditManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { PageLayout } from '@/shared/ui/PageLayout';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/activities/$activityId/edit')({
    staticData: { access: { permissions: canEditManufacturingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <PageLayout layout="full-width">
            <EditActivityForm activityId={pathParams.activityId} />
        </PageLayout>
    );
}
